import { formatDate, getDateDifference, pluralize } from '@travelata-libs/utils';
import { getAnchor, getMinDate, parseDate } from '@/entities/searchCriteria';
import type { DateRange } from '@/shared/model';
import { DATE_FROM_TEXTS } from '../config/texts';

const DAYS_FORMS = ['день', 'дня', 'дней'];

export function flexCountWord(n: number): string {
  return pluralize(DAYS_FORMS, n);
}

export function formatDdMm(d: Date): string {
  return formatDate(d, 'dd.MM');
}

export function formatDdMmYyyy(d: Date): string {
  return formatDate(d, 'dd.MM.yyyy');
}

function flexCoversRange(value: DateRange, anchor: Date): boolean {
  if (value.daysFlexible <= 0) {
    return false;
  }
  const daysFromTomorrow = Math.abs(getDateDifference(getMinDate(), anchor, 'days'));
  return daysFromTomorrow >= value.daysFlexible;
}

export function formatDateValue(value: DateRange, anchor: Date): string {
  const { valuePrefix, rangeJoin, flexSign } = DATE_FROM_TEXTS;

  if (value.from !== value.to) {
    if (flexCoversRange(value, anchor)) {
      return `${valuePrefix}${formatDdMm(anchor)} ${flexSign} ${flexCountWord(value.daysFlexible)}`;
    }
    return `${valuePrefix}${formatDdMm(parseDate(value.from))}${rangeJoin}${formatDdMm(parseDate(value.to))}`;
  }

  return `${valuePrefix}${formatDdMmYyyy(parseDate(value.from))}`;
}

export function formatMobileDateValue(value: DateRange): string {
  const { flexSign, mobileRangeJoin } = DATE_FROM_TEXTS;
  const anchor = getAnchor(value);

  if (value.from === value.to) {
    return formatDate(parseDate(value.from), 'd MMMM');
  }

  if (flexCoversRange(value, anchor)) {
    return `${formatDate(anchor, 'd MMMM')} ${flexSign}${flexCountWord(value.daysFlexible)}`;
  }

  return `${formatDate(parseDate(value.from), 'd.MM')}${mobileRangeJoin}${formatDate(parseDate(value.to), 'd.MM')}`;
}

export function formatCheckInLabel(value: DateRange): string {
  return formatDdMm(getAnchor(value));
}

export function formatCheckInDayMonth(value: DateRange): string {
  return formatDate(getAnchor(value), 'd MMM');
}
